// @flow

export const getPlayerUrl = (id: any, webp?: boolean) => (
	`${process.env.REACT_APP_PLAYERS_PATH + id}_100.${webp ? "webp" : "png"}`
);

export default getPlayerUrl;